import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CsSelect } from 'components/antd-extension/CsSelect';
import { QueryType } from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { IssueAiStatus } from 'utils/constants/issue-ai-status';

const IssueAiStatusSelect = ({
  isReadOnly,
  fieldValue,
  onChangeFieldValue,
}) => {
  const { t } = useTranslation();

  // 定义所有可能的选项值
  const allOptionValues = useMemo(() => [
    IssueAiStatus.NONE,
    IssueAiStatus.USER_GENERATED,
    IssueAiStatus.SYSTEM_GENERATED,
  ], []);

  // 定义选项
  const options = useMemo(() => [
    { 
      label: t('issueAiStatusOptions.未分析'), 
      value: IssueAiStatus.NONE 
    },
    { 
      label: t('issueAiStatusOptions.在线分析'), 
      value: IssueAiStatus.USER_GENERATED 
    },
    { 
      label: t('issueAiStatusOptions.离线分析'), 
      value: IssueAiStatus.SYSTEM_GENERATED 
    },
  ], [t]);

  const {
    terms,
    not,
  } = fieldValue || {};

  // 根据 fieldValue 计算当前选中的值
  const currentValue = useMemo(() => {
    if (!terms || terms.length === 0) {
      return [];
    }
    
    if (not) {
      // 如果是取反模式，返回所有选项中排除 terms 的部分
      return allOptionValues.filter(v => !terms.includes(v));
    } else {
      // 正常模式，直接返回 terms
      return terms;
    }
  }, [terms, not, allOptionValues]);

  // 处理值变化
  const handleChange = (selectedValues) => {
    if (isReadOnly) {
      return;
    }

    if (!selectedValues || selectedValues.length === 0) {
      // 清空选择
      onChangeFieldValue({ queryType: QueryType.TERMS, terms: [], not: false });
      return;
    }

    // 判断是否包含 NONE
    const includesNone = selectedValues.includes(IssueAiStatus.NONE);

    if (includesNone) {
      // 包含 NONE，使用取反模式
      // terms 是所有选项中排除 selectedValues 的部分
      const invertedTerms = allOptionValues.filter(v => !selectedValues.includes(v));
      onChangeFieldValue({ 
        queryType: QueryType.TERMS, 
        terms: invertedTerms, 
        not: true 
      });
    } else {
      // 不包含 NONE，正常模式
      onChangeFieldValue({ 
        queryType: QueryType.TERMS, 
        terms: selectedValues, 
        not: false 
      });
    }
  };

  return (
    <CsSelect
      style={{ width: '100%', fontSize: '14px' }}
      mode='multiple'
      allowClear
      options={options}
      placeholder={t('issueCrashFilter.anyPlaceholder')}
      value={currentValue}
      onChange={handleChange}
    />
  );
};

export default IssueAiStatusSelect;

